{% block acris_blog_author_detail %}
    <sw-page class="acris-blog-author-detail" v-if="item">

        {% block acris_blog_author_detail_smart_bar_header %}
            <template #smart-bar-header>
                {% block acris_blog_author_detail_smart_bar_header_title %}
                    <h2>
                        <template v-if="item.firstName && item.lastName">
                            {{ item.firstName }} {{ item.lastName }}
                        </template>
                        <template v-else>
                            {{ $tc('acris-blog-author.detail.textHeadline') }}
                        </template>
                    </h2>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_author_detail_smart_bar_actions %}
            <template #smart-bar-actions>
                {% block acris_blog_author_detail_smart_bar_actions_cancel %}
                    <mt-button :disabled="item.isLoading" @click="$router.push({ name: 'acris.blog.author.index' })" size="default" variant="secondary">
                        {{ $tc('acris-blog-author.detail.buttonCancel') }}
                    </mt-button>
                {% endblock %}

                {% block acris_blog_author_detail_smart_bar_actions_save %}
                    <sw-button-process
                            :isLoading="isLoading"
                            :processSuccess="processSuccess"
                            variant="primary"
                            :disabled="!item.firstName || !item.lastName"
                            @update:processSuccess="saveFinish"
                            @click="onClickSave">
                        {{ $tc('acris-blog-author.detail.buttonSave') }}
                    </sw-button-process>
                {% endblock %}
            </template>
        {% endblock %}

        {% block acris_blog_author_detail_content %}
            <template #content>
                <sw-card-view>

                    {% block acris_blog_author_detail_settings_card %}
                        <mt-card :isLoading="isLoading" v-if="item"
                                 position-identifier="acris-blog-author-detail-settings"
                                 :title="$tc('acris-blog-author.detail.cardSettingsTitle')">

                            <sw-container columns="1fr 1fr" gap="0 32px">
                                {% block acris_blog_author_detail_first_name %}
                                    <mt-text-field v-model="item.firstName"
                                                   required
                                                   :label="$tc('acris-blog-author.detail.fieldTitleLabelFirstName')"
                                                   :placeholder="placeholder(item, 'firstName', $tc('acris-blog-author.detail.fieldTitlePlaceholderFirstName'))">
                                    </mt-text-field>
                                {% endblock %}

                                {% block acris_blog_author_detail_last_name %}
                                    <mt-text-field v-model="item.lastName"
                                                   required
                                                   :label="$tc('acris-blog-author.detail.fieldTitleLabelLastName')"
                                                   :placeholder="placeholder(item, 'lastName', $tc('acris-blog-author.detail.fieldTitlePlaceholderLastName'))">
                                    </mt-text-field>
                                {% endblock %}
                            </sw-container>

                        </mt-card>
                    {% endblock %}

                </sw-card-view>
            </template>
        {% endblock %}

    </sw-page>
{% endblock %}
